/*
 * @Author: 小周
 * @Date: 2023-09-07 16:45:50
 * @LastEditTime: 2024-07-26 10:36:33
 * @LastEditors: MrZHLF
 * @Description:
 */

import { isCheckApp } from '@/utils/index'
import { getTokenInAppAndRedirect } from '@/utils/appMethods'
import { getToken, setToken, rmToken } from '@/utils/tokenStore'
import { setUser, rmUser } from '@/utils/userStore'
import { getUserInfo } from '@/api/user'
import { Toast } from 'react-vant'

export async function isLogin() {
  let isStatus = false
  let isApp = await isCheckApp()
  if (isApp) {
    // App环境
    const res = await getTokenInAppAndRedirect()
    setToken(res)
    if (getToken()) {
      // token存在
      let user = await getUserInfo()
      if (user.code == 0) {
        setUser(user.result)
        isStatus = true
      } else {
        Toast(user.msg)
        isStatus = false
      }
    } else {
      // 不存在
      rmUser()
      rmToken()
      isStatus = false
    }
  } else {
    // H5环境
    let realUserInfo = localStorage.getItem('realUserInfo')
      ? JSON.parse(localStorage.getItem('realUserInfo'))
      : null
    const userInfo = window.localStorage.getItem('userInfo')

    if (realUserInfo && realUserInfo.id) {
      isStatus = true
      setUser(realUserInfo || userInfo)
    } else {
      window.oauth.authAndBind = true
      window.oauth?.oauth()
      isStatus = false
    }
  }

  return {
    isStatus,
  }
}
